import * as React from 'react';

import FadeIn from '@/components/FadeIn/FadeIn';
import GlobeIcon from '@/assets/icons/GlobeIcon';
import LockIcon from '@/assets/icons/LockIcon';
import SeedIcon from '@/assets/icons/SeedIcon';

const TIMELINE = [
  {
    title: 'Planting the seed',
    description:
      'We began building marketbetter to replace manual marketing workflows with autonomous AI agents in early-2025.',
    icon: SeedIcon,
  },
  {
    title: "How it's going",
    description:
      'By early 2025, our prototype evolved into a powerful platform—giving teams a catalog of plug-and-play GTM Agents that handle prospecting, email sequences, ad management, and CRM updates automatically.',
    icon: LockIcon,
  },
  {
    title: 'Impact at scale',
    description:
      'In Summer 2025, we launched marketbetter.ai with AI agents that automate entire mar-tech stacks for fast-growing B2B teams. We help reps save 12+ hours a week and close deals 40% faster.',
    icon: GlobeIcon,
  },
];

const Timeline: React.FC = () => (
  <section className='bg-white py-16 md:py-20'>
    <div className='container mx-auto px-4 md:px-8 xl:px-10'>
      <FadeIn variant='down' delay={0.2}>
        <h2 className='text-4xl md:text-[44px] leading-[61px] mb-2 font-medium text-center'>
          How we started
        </h2>
        <p className='text-center text-black/60 mb-12 mx-auto text-xl md:text-[24px] leading-[32px]'>
          Every week your team wastes hours pulling ad reports, matching IPs to companies, and
          nudging reps to follow up—work that should have happened while the buyer was still
          interested. marketbetter ends that grind with autonomous AI agents.
        </p>
      </FadeIn>

      {/* Timeline Line */}
      <div className='hidden md:block relative w-full mb-4'>
        <div className='flex justify-between items-center relative h-[18px] gap-8'>
          {/* Horizontal Line */}
          <div className='absolute h-[1px] bg-blue-500 w-screen left-[50%] translate-x-[-50%] top-1/2'></div>
          <div className='absolute h-[1px] bg-blue-500 w-[calc(67%+2rem)] top-1/2'></div>
          <div className='absolute h-[1px] border-t border-dashed border-blue-300 w-[calc(33%-2rem)] right-0 top-1/2'></div>

          {/* Circles */}
          <div className='flex-1 z-10'>
            <div className='w-[18px] h-[18px] rounded-full border border-blue-500 bg-white flex items-center justify-center'>
              <div className='w-[12px] h-[12px] rounded-full bg-blue-50'></div>
            </div>
          </div>

          <div className='flex-1 z-10'>
            <div className='w-[18px] h-[18px] rounded-full border border-blue-500 bg-white flex items-center justify-center'>
              <div className='w-[12px] h-[12px] rounded-full bg-blue-50'></div>
            </div>
          </div>

          <div className='flex-1 z-10'>
            <div className='w-[18px] h-[18px] rounded-full border border-dashed border-blue-300 bg-white flex items-center justify-center'>
              <div className='w-[12px] h-[12px] rounded-full bg-blue-50'></div>
            </div>
          </div>
        </div>
      </div>

      <div className='flex flex-col md:flex-row justify-center gap-8 relative z-[1]'>
        {TIMELINE.map((item, idx) => (
          <FadeIn
            key={idx}
            variant='up'
            delay={0.3 + idx * 0.1}
            className='flex-1 bg-white rounded-2xl px-3 py-9 shadow-xl text-center md:min-h-[485px]'
          >
            <div className='w-18 h-18 bg-[#eefdf7]/80 rounded-md mb-3 mx-auto flex justify-center items-center'>
              <item.icon width={36} height={36} />
            </div>
            <h3 className='text-xl md:text-[32px] font-medium text-blue-500 mb-3'>{item.title}</h3>
            <p className='text-black/60 text-base md:text-[24px] leading-[32px]'>
              {item.description}
            </p>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default Timeline;
